import { Controller } from "@hotwired/stimulus";

// Sends GA4 events for marked CTAs. No-ops when analytics is not loaded
// (no consent, development, ad blockers).
export default class extends Controller {
  // Marks the controller as wired so system specs can wait before clicking a
  // tracked CTA: a click before connect never reaches the action (the listener
  // is not attached yet), which is a one-shot no-op and a source of flakiness.
  connect() {
    this.element.setAttribute("data-analytics-ready", "");
  }

  // Clear the marker on teardown so it always means "a listener is attached right
  // now" rather than "one was attached at some point" — otherwise the attribute
  // survives into a Turbo-cached snapshot and a wait on it can pass before the
  // click action is live again.
  disconnect() {
    this.element.removeAttribute("data-analytics-ready");
  }

  track(event) {
    if (typeof window.gtag !== "function") {return;}

    const { event: name = "cta_click", location = "" } = event.params;
    window.gtag("event", name, { location });
  }
}
